'use strict';

// Object.assign browser polyfill required for IE11, from: https://gist.github.com/spiralx/68cf40d7010d829340cb
if (!Object.assign) {
  Object.defineProperty(Object, 'assign', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function (target) {
      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert first argument to object');
      }
      var to = Object(target);
      for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) {
          continue;
        }
        nextSource = Object(nextSource);
        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
      return to;
    }
  });
}

basecoat.FlatPickr = require('flatpickr');
basecoat.FlatPickrConfirmDate = require('flatpickr/dist/plugins/confirmDate/confirmDate');

+function ($) {

  $.fn.datetimePicker = function (options) {
    options = options || {
      closeOnSelect: false,
      altInput: true, // todo: logs warnings in IE (why?) but seems to work
      altFormat: 'j M Y',
      minuteIncrement: 15,
      onOpen: function (selectedDates, dateStr, instance) {
        // by default flatpickr doesn't set a value unless the user changed something in the widget, but with the ConfirmDate plugin a user might just click select on the default value (eg 12:00am) so lets set a value on `open`.
        if (selectedDates.length === 0) {
          instance.setDate('00:00');
        }
        // todo: add clear + cancel buttons to date-picker
      },
      onClose: function (selectedDates, dateStr, instance) {
        $(instance.element).blur(); // blur the field to trigger validation
      },
      plugins: [new basecoat.FlatPickrConfirmDate({
        confirmIcon: '',
        confirmText: 'Select',
        showAlways: true
      })]
    };
    return this
    .find('[data-datetime-picker]')
    .addBack('[data-datetime-picker]')
    .each(function () {
      $(this).flatpickr(options);
    });
  };

  basecoat.init.datetimePicker = function () {
    $(this).datetimePicker();
  };

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/datetime-picker.js
// module id = 4
// module chunks = 0